import WebLayout from './ProfileMentionLayout.web';
import MobileLayout from './ProfileMentionLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
